import { render, staticRenderFns } from "./infoTaskTab.vue?vue&type=template&id=4fab118a&scoped=true&"
import script from "./infoTaskTab.vue?vue&type=script&lang=js&"
export * from "./infoTaskTab.vue?vue&type=script&lang=js&"
import style0 from "./infoTaskTab.vue?vue&type=style&index=0&id=4fab118a&prod&lang=less&scoped=true&"
import style1 from "./infoTaskTab.vue?vue&type=style&index=1&id=4fab118a&prod&lang=scss&"
import style2 from "./infoTaskTab.vue?vue&type=style&index=2&id=4fab118a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fab118a",
  null
  
)

export default component.exports